<template>
  <v-dialog v-model="dialog" @input="v => v || closeDialog()" max-width="688px">
    <v-card class="d-flex justify-content-center">
      <v-card-text class="content-modl">
        <v-img
          @click="closeDialog"
          class="cancel-image"
          src="../assets/icons/cancel.png"
          height="15px"
          width="15px"
        />
        <div class="text-center py-3">
          <h3>{{ dialogTitle }}</h3>
        </div>

        <div class="d-flex mob-res" style="text-align: center;">
          <div>
            <v-btn small class="mr-2 mob-mar" dark color="primary"
              @click="clearAlarmCount < 3 ? $emit('buttonPush', 'clearalarm', boxData) : null"
            >
              <span>{{ "lng_clear_alram_btn" | translate }}</span>
              <v-icon right dark>mdi-bell-off</v-icon>
            </v-btn>
          </div>
          <div>
            <v-btn small class="link-button mr-2 mob-mar" color="primary" dark @click="goToEventLogs">
              {{ "lng_menu_history" | translate }}
              <v-icon right dark>mdi-calendar</v-icon>
            </v-btn>
          </div>
          <div>
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small
                  class="link-button mr-2" dark color="primary"
                  v-bind="attrs"
                  v-on="on"
                >
                <span>{{ "lng_test_alram_btn" | translate }}</span>
                  <v-icon right dark>mdi-alarm</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in testAlarmOptions"
                  :key="index"
                >
                  <v-list-item-title style="cursor: pointer;" @click="testAlarmCount < 3 ? $emit('buttonPush', item.action, boxData) : null">
                    {{ item.title | translate }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>

        <p class="mt-6">
          <strong>{{ "lng_th_systemId" | translate }}:</strong>
          {{boxData.id}}
        </p>
        <p>
          <strong>{{ "lng_system_state_txt" | translate }}:</strong>
          {{chooseMapPin(boxData.sysstate)}}
        </p>
        <p>
          <strong>{{ "lng_th_address" | translate }}:</strong>
          {{boxData | formatAddress}}
        </p>
        <p>
          <strong>{{ "lng_th_alarm_phone" | translate }}:</strong>
          {{boxData.alarmsms}}
        </p>
        <p>
          <strong>{{ "lng_th_alarm_email" | translate }}:</strong>
          {{boxData.alarmemail}}
        </p>
        <p>
          <strong>{{ "lng_sewer_type_txt" | translate }}:</strong>
          {{boxData.sewertype}}
        </p>
        <p>
          <strong>{{ "lng_equipment_type_txt" | translate }}:</strong>
          {{equipmentTypeLabel}}
        </p>

        <!-- Rssi Hover -->
        <div class="rssi">
          <strong>{{ "lng_th_rssi" | translate }}:</strong>
          <p class="rssi-icon">
            <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <p v-bind="attrs" v-on="on" v-if="boxData.rssi >= 1 && boxData.rssi < 5 ">
                    <v-icon color="red">mdi-antenna</v-icon>
                  </p>
                  <p v-bind="attrs" v-on="on" v-else-if="boxData.rssi >= 5  && boxData.rssi < 7">
                    <v-icon color="orange">mdi-antenna</v-icon>
                  </p>
                  <p v-bind="attrs" v-on="on" v-else-if="boxData.rssi >= 7  && boxData.rssi <= 9">
                    <v-icon color="yellow">mdi-antenna</v-icon>
                  </p>
                  <p v-bind="attrs" v-on="on" v-else-if="boxData.rssi >= 10  && boxData.rssi <= 12">
                    <v-icon color="blue">mdi-antenna</v-icon>
                  </p>
                  <p v-bind="attrs" v-on="on" v-else-if="boxData.rssi >= 13  && boxData.rssi < 20">
                    <v-icon color="purple">mdi-antenna</v-icon>
                  </p>
                  <p v-bind="attrs" v-on="on" v-else-if="boxData.rssi >= 20">
                    <v-icon color="green">mdi-antenna</v-icon>
                  </p>
                  <p v-bind="attrs" v-on="on" v-else>
                    Not Found
                  </p>
                </template>
                <span>{{"lng_th_rssi" | translate}} : {{boxData.rssi}}</span><br>
                <span>{{"lng_th_rssi_date" | translate}} : {{parseRssiDate}}</span>
            </v-tooltip>
          </p>
        </div>
        <!-- Rssi Hover -->

        <p>
          <strong>{{ "lng_th_subscription_txt" | translate }}:</strong>
          {{subscriptionLabel}}
        </p>
        <p>
          <strong>{{ "lng_th_service_contract_txt" | translate }}:</strong>
          {{serviceContractLabel}}
        </p>
        <p>
          <strong>{{ "lng_th_service_email" | translate }}:</strong>
          {{boxData.serviceemail}}
        </p>
        <p>
          <strong>{{ "lng_th_service_date_txt" | translate }}:</strong>
          {{serviceDateLabel}}
        </p>
        <p>
          <strong>{{ "lng_th_days_till_service" | translate }}:</strong>
          {{daysTillServiceLabel}}
        </p>
        <p>
          <strong>{{ "lng_th_operation_email" | translate }}:</strong>
          {{boxData.operationemail}}
        </p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import router from "../router";
import { translateFunc } from '../common/Filters';
import { formatSubscriptionTierLabel } from '../common/HelperFunctions';
import { equipmentTypeValues } from '../common/Constant';
import moment from "moment";

export default {
  name: "MarkerModal",
  data() {
    return {
      dialog: false,
      clearAlarmCount: 0,
      testAlarmCount: 0,
      testAlarmOptions: [
        { title: 'test_alarm_option1', action: "testalarm" },
        { title: 'test_alarm_option2', action: "testalarmemail" },
        { title: 'test_alarm_option3', action: "testalarmsms" }
      ],
    };
  },
  props: {
    openDialog: {
      type: Boolean,
      default: false
    },
    closeDialog: {
      type: Function,
      default: undefined
    },
    dialogTitle: {
      type: String,
      default: "Dialog"
    },
    boxData: {
      type: Object,
      default: () => {}
    },
    userToken: {
      type: String,
      default: ""
    }
  },
  watch: {
    openDialog: function(newVal) {
      this.dialog = newVal;
    }
  },
  computed: {
    parseRssiDate(){
      return moment(this.boxData?.rssidate).format("DD/MM-YYYY HH:mm:ss")
    },
    equipmentTypeLabel() {
      const eqTypeIndex = equipmentTypeValues.findIndex(
        (e) => e.value === this.boxData?.uwsequipment
      );
      if (eqTypeIndex !== -1) {
        return translateFunc(equipmentTypeValues[eqTypeIndex].name);
      }
      return this.boxData?.uwsequipment || '';
    },
    subscriptionLabel() {
      return formatSubscriptionTierLabel(this.boxData?.subscription);
    },
    serviceContractLabel() {
      return this.boxData?.servicecontract == "1"
        ? translateFunc("lng_yes_txt")
        : translateFunc("lng_no_txt");
    },
    serviceDateLabel() {
      return this.boxData?.lastservice
        ? moment(this.boxData.lastservice).format("DD/MM-YYYY")
        : '';
    },
    daysTillServiceLabel() {
      const days = this.boxData?.daystillservice;
      if (days === undefined || days === null || days === '') return '';
      return days;
    },
  },
  mounted() {},
  methods: {
    goToEventLogs(){
      router.push("/event-logs");
    },
    chooseMapPin(status) {
      if (status === "0") {
        return translateFunc("lng_marker_green");
      } else if (status === "1") {
        return translateFunc("lng_marker_red");
      } else {
        return translateFunc("lng_marker_grey");
      }
    },
  }
};
</script>
<style>
.fields-group {
  position: relative;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 15px 10px 0px 10px;
}
.group-title {
  background-color: rgb(11, 120, 148, 0.7);
  color: #fff;
  position: absolute;
  top: -10px;
  padding: 0 10px;
  border-radius: 50px;
}
.theme--light.v-card > .v-card__text {
  color: #000;
  width: 95%;
}
.cancel-image {
  position: absolute;
  top: 1rem;
  right: 1rem;
}
.v-dialog > .v-card {
  background-image: linear-gradient(to top, #8aa8ad, transparent);
}
.v-overlay.v-overlay--active.theme--dark {
  z-index: 99991 !important;
}
.v-dialog__content.v-dialog__content--active {
  z-index: 99992 !important;
}
.rssi{
  display: flex;
}
.rssi-icon{
margin-left: 10px;
}
@media only screen and (max-width: 480px){
	.content-modl div.mob-res{
		display: block !important;
	}
	.mob-mar{
		margin-bottom:10px;
	}
}
</style>
